import { defineComponent as _, mergeModels as r, useId as b, useModel as w, computed as y, watch as V, createElementBlock as x, openBlock as c, createElementVNode as i, withDirectives as I, createBlock as k, createCommentVNode as $, createVNode as g, unref as t, withKeys as B, vModelText as C } from "vue";
import { RevButtonIcon as M } from "@ds/components/ButtonIcon";
import P from "../../../icons/generated/IconCrossInCircle.vue2.js";
import N from "../../../icons/generated/IconSearch.vue2.js";
import { useI18n as S } from "@ds/plugin";
import u from "../../../translations/generic.translations.js";
const z = { class: "relative" }, E = { class: "absolute left-16 top-1/2 -translate-y-1/2 p-8" }, K = ["placeholder"], A = /* @__PURE__ */ _({
  __name: "InputSelectSearchableSearch",
  props: /* @__PURE__ */ r({
    searchPlaceholder: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ r(["close", "update:modelValue"], ["update:modelValue"]),
  setup(a, { emit: d }) {
    const m = a, p = d, f = `${b()}_input_select_search`, n = S(), e = w(a, "modelValue"), h = y(
      () => m.searchPlaceholder || n(u.searchPlaceholder)
    );
    function v() {
      e.value = "";
    }
    return V(e, (l) => p("update:modelValue", l)), (l, o) => (c(), x("div", z, [
      i("div", E, [
        g(t(N), { class: "text-static-default-low size-24" })
      ]),
      I(i("input", {
        id: f,
        ref: "input",
        "onUpdate:modelValue": o[0] || (o[0] = (s) => e.value = s),
        class: "bg-action-default-min text-action-default-low focus-visible-outline-default-hi h-56 w-full rounded-none py-8 pl-64 pr-56 placeholder:text-action-default-low focus:text-action-default-low-pressed md:rounded-t-sm focus:-outline-offset-2",
        placeholder: h.value,
        type: "text",
        onKeydown: o[1] || (o[1] = B((s) => l.$emit("close"), ["esc"]))
      }, null, 40, K), [
        [C, e.value]
      ]),
      e.value ? (c(), k(t(M), {
        key: 0,
        "aria-label": t(n)(t(u).buttonClear),
        class: "text-action-default-low pointer-events-auto absolute right-8 top-1/2 size-24 -translate-y-1/2 p-8",
        "data-test": "clear-button",
        icon: t(P),
        type: "button",
        variant: "secondary",
        onClick: v
      }, null, 8, ["aria-label", "icon"])) : $("", !0)
    ]));
  }
});
export {
  A as default
};
